import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

// Create query client instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      refetchOnWindowFocus: false,
    },
  },
});

// Create router instance
export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  // Preload critical routes on app load
  defaultPendingComponent: () => <div>Loading...</div>,
});

// Preload home page immediately
if (typeof window !== "undefined") {
  router.preloadRoute({ to: "/" });
}

// Type declaration for router context
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
